<template>
  <bk-page
    class="missEmail"
    pageType="navRoot"
    :navBarInfo="navBarInfo"
    @close="handleClose"
  >
    <!--    <template #slot-leftItems>-->
    <!--      <bk-view class="titleWrap">-->
    <!--        <bk-title>{{ isUnsubscribe ? 'Unsubscribe' : 'Subscribe' }}</bk-title>-->
    <!--      </bk-view>-->
    <!--    </template>-->
    <bk-view class="page-container" v-if="isUnsubscribe">
      <bk-image style="width: 64px;" :src="$bk_getImageUrl('Def_Image_Unsubscribed.png')"/>
      <bk-title>Successfully Unsubscribed</bk-title>
      <bk-view class="view-tips">You Will No Longer Receive Emails From {{ compName }}</bk-view>
      <bk-view>Accidentally Unsubscribe?</bk-view>
      <bk-button type="text" underline @click="resubscribe">Resubscribe</bk-button>
    </bk-view>
    <bk-view class="page-container subscribe" v-else>
      <bk-image style="width: 290px;" :src="$bk_getImageUrl('Def_Image_Subscribed.png')"/>
      <bk-view class="view-tips">You Will Continue To Receive Emails From {{ compName }}</bk-view>
    </bk-view>
  </bk-page>
</template>

<script>

	import {connectReq} from '../../reqService';
	import BkTitle from '../../components/bk-base/bk-title/bk-title.vue';

	export default {
		name: 'missEmail',
		components: {BkTitle},
		props: {},
		data () {
			return {
				key: '',
				isUnsubscribe: 0,
				compName: '',
			};
		},
		computed: {
			navBarInfo () {
				return {
					backFlag: true,
					title: this.isUnsubscribe ? 'Unsubscribe' : 'Subscribe',
					// titleAlign: 'center',
				};
			}
		},
		watch: {},
		methods: {
			getData () {
				if (!this.key) {
					this.getSubscribeKey();
					return;
				}
				connectReq.requestEmailUnsubscribeStatus(this, this.key).then((res) => {
					if(res){
						this.isUnsubscribe = res.isUnsubscribe;
						this.compName = res.compName;
					}else{
						this.getSubscribeKey();
					}
				});
			},
			getSubscribeKey () {
				const {compId, email} = this.$route.query;
				connectReq.requestEmailSubscribeKey(this, {compId, email} ).then((res) => {
					this.key = res.subscribeKey;
					this.isUnsubscribe = res.isUnsubscribe;
					this.compName = res.compName;
				});
			},
			resubscribe () {
				connectReq.requestEmailResubscribe(this, this.key).then(() => {
					this.getData();
				});
			},
			handleClose () {
				this.$router.replace('/login');
			}
		},
		mounted () {
			this.key = this.$route.query.key;
			this.getData();
		}
	};
</script>

<style lang="less">
.missEmail {

  //.view-leftItems {
  //  background: #F7F7F7;
  //  width: 100%;
  //
  //  .titleWrap {
  //    width: 100%;
  //    display: flex;
  //    align-items: center;
  //    justify-content: center;
  //  }
  //}

  .page-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 96px;

    > .bk-title {
      margin: 24px auto;
    }

    > .view-tips {
      margin-bottom: 48px;
      padding: 0 40px;
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      line-height: 16px;
    }

    > .bk-button {
      text-decoration: underline;
      color: #2E56F2;
      margin-top: 8px;
    }

    &.subscribe {

      > .view-tips {
        margin-top: 40px;
        padding: 0 40px;
        text-align: center;

        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 16px;
      }
    }
  }
}
</style>